import styled from 'styled-components';
import { color, typography } from 'styles/settings';
import { normalize } from 'utils/styles';
import { P } from 'components/typography';

export const Container = styled.div`
  background-color: ${color.neutral.white};
  border-radius: 10px;
`;

export const Header = styled.div`
  margin-bottom: ${normalize('30px')};
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
`;

export const Title = styled.span`
  ${typography.font.title.bold};
  font-size: ${typography.size.xxxl};
  line-height: ${normalize('81px')};
`;

export const Section = styled.div`
  margin: ${normalize('60px')};
  margin-top: ${normalize('10px')};
`;

export const Description = styled(P).attrs({ secondary: true })`
  color: #343434;
`;

export const OptionText = styled.div`
  align-items: center;
  display: block;
  ${typography.font.medium};
  font-size: ${typography.size.md};
  line-height: ${typography.size.lg};
`;

export const OptionLink = styled.span`
  ${typography.font.semiBold};
  color: ${color.brand.greenDark};
`;
